window.Box = window.Box ?? {};

window.Box.boxObserver = window.Box.boxObserver ?? {};

window.Box = {
    setup: () => {
        const mutationCallback = (mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type !== "attributes" || (mutation.attributeName.indexOf("data-unread") < 0 && mutation.attributeName.indexOf("data-count") < 0)) {
                    return;
                }

                $(mutation.target).find(".lookup").addClass("flashing");
                window.setTimeout(function () {
                    $(mutation.target).find(".lookup").removeClass("flashing");
                }, 300);
            }
        }

        window.Box.boxObserver = new MutationObserver(mutationCallback);
    },

    observe: () => {
        var eles = document.querySelectorAll(".filtr-item");

        Array.from(eles).forEach(box => {
            window.Box?.boxObserver?.observe(box, { attributes: true });
        });
    },

    stop: () => {
        window.Box?.boxObserver?.disconnect();
    }
}